import { Snackbar } from 'src/app/shared/types/snackbar';

export const snackbarCreatorSucceedObject: Snackbar = {
  duration: 2000,
  message: 'profile.creator_details.success_message',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'approved-snackbar',
};

export const snackbarCreatorFailedObject: Snackbar = {
  duration: 2000,
  message: 'profile.creator_details.failed_message',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'error-snackbar',
};
